module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/115.067e6ea2.png";